export const CONTACT = {
    brand: "Julians Gartenservice",
    phoneDisplay: "0173 4793540",
    phoneHref: "tel:+491734793540",
    email: "julian-gartenservice@gmx.de",
    whatsapp: "https://wa.me/491734793540?text=Hallo%20Julian%2C%20ich%20interessiere%20mich%20f%C3%BCr%20ein%20Angebot%20von%20Julians%20Gartenservice.",
    region: "Landkreis Celle & Umgebung",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1764197943918-f0a5b2d739fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NDQ2NDF8MHwxfHNlYXJjaHwxfHxsdXh1cmlvdXMlMjBtYW5pY3VyZWQlMjBnYXJkZW4lMjBwYXRpbyUyMGxhd258ZW58MHx8fHwxNzg4NjM0NTg1fDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
    {
        id: "heckenschnitt",
        num: "01",
        title: "Heckenschnitt",
        selectValue: "Heckenschnitt",
        badge: "Formschnitt & Rückschnitt",
        desc: "Präziser Form- und Rückschnitt mit sauberen Kanten. Auf Wunsch nehmen wir das Schnittgut direkt mit.",
        features: ["Form- & Pflegeschnitt", "Exakte Kanten und gerade Linien", "Schnittgut-Entsorgung inklusive"],
        image: "/leistung-heckenschnitt.webp",
        alt: "Heckenschnitt in Celle – Julian mit der Heckenschere an der Hecke",
    },
    {
        id: "pflasterreinigung",
        num: "02",
        title: "Pflasterreinigung",
        selectValue: "Pflasterreinigung",
        badge: "Vorher-Nachher-Effekt",
        desc: "Terrassen, Einfahrten und Gehwege porentief gereinigt – frei von Grünbelag, Moos und Unkraut.",
        features: ["Terrassen, Einfahrten & Wege", "Entfernung von Grünbelag & Moos", "Schonend für Pflaster & Naturstein"],
        image: "/leistung-pflasterreinigung.webp",
        alt: "Pflasterreinigung in Celle – frisch gereinigter Pflasterweg",
    },
    {
        id: "rasenpflege",
        num: "03",
        title: "Rasenpflege & Rasenreparatur",
        selectValue: "Rasenpflege & Rasenreparatur",
        badge: "Dicht & gepflegt",
        desc: "Regelmäßiges Mähen, gezielte Pflege und die Reparatur lückenhafter Flächen – inklusive Nachsaat.",
        features: ["Regelmäßiges Mähen", "Reparatur kahler Stellen", "Nachsaat für ein dichtes Rasenbild"],
        image: "/leistung-rasenpflege.webp",
        alt: "Rasenpflege in Celle – Julian auf dem Aufsitzmäher beim Mähen",
    },
    {
        id: "laubentfernung",
        num: "04",
        title: "Laubentfernung",
        selectValue: "Laubentfernung",
        badge: "Herbst & Frühjahr",
        desc: "Gründliche Laubentfernung auf Rasenflächen, Wegen und dem gesamten Grundstück – mit Abtransport.",
        features: ["Rasen, Wege & Außenanlagen", "Schutz vor Fäulnis & Rutschgefahr", "Abtransport inklusive"],
        image: "/leistung-laubentfernung.webp",
        alt: "Laubentfernung in Celle – Julian mit dem Laubbläser im Herbstlaub",
    },
];

export const SECONDARY_SERVICES = [
    { title: "Außenreinigung", desc: "Reinigung von Mauern, Treppen und Außenanlagen." },
    { title: "Dachrinnenreinigung", desc: "Freie Rinnen für ungestörten Wasserablauf." },
    { title: "Unkrautentfernung & Beetpflege", desc: "Saubere Beete und fugenfreies Pflaster." },
    { title: "Zaun- & Holzpflege", desc: "Reinigung und Pflege von Zäunen und Sichtschutz." },
    { title: "Grundstückspflege", desc: "Regelmäßige Betreuung für Vermieter & Gewerbe." },
];

export const BEFORE_AFTER = [
    {
        id: "pflaster",
        title: "Pflaster- & Terrassenreinigung",
        before: "/vn-pflaster-vorher.webp",
        after: "/leistung-pflasterreinigung.webp",
        labelBefore: "Verschmutzt & Grünbelag",
        labelAfter: "Porentief gereinigt",
        caption: "Echtes Projekt — Pflasterweg im Landkreis Celle vor und nach der Reinigung",
    },
    {
        id: "hecke",
        title: "Hecken-Formschnitt",
        before: "/vn-hecke-vorher.webp",
        after: "/vn-hecke-nachher.webp",
        labelBefore: "Überwachsen",
        labelAfter: "Präzise geschnitten",
        caption: "Echtes Projekt — Hecken-Formschnitt im Landkreis Celle",
    },
];

export const WHY_US = [
    { num: "01", title: "Saubere Ausführung", desc: "Wir arbeiten ordentlich und hinterlassen Grundstücke sauber. Schnittgut, Laub und anfallender Schmutz werden nach der Arbeit mitgenommen." },
    { num: "02", title: "Direkter Ansprechpartner", desc: "Von der ersten Anfrage bis zum Abschluss bleibt Ihr Auftrag in einer Hand. Sie sprechen direkt mit Julian – ohne Vermittlung und ohne wechselnde Ansprechpartner." },
    { num: "03", title: "Klare Angebote", desc: "Nach Besichtigung oder anhand aussagekräftiger Fotos erhalten Sie ein transparentes Angebot. Keine versteckten Kosten und keine Überraschungen." },
    { num: "04", title: "Professionelle Technik", desc: "Für Gartenpflege und Außenreinigung setzen wir passende Maschinen und professionelle Reinigungstechnik ein. So können wir Arbeiten effizient und materialgerecht ausführen." },
];

export const PROCESS = [
    { step: "01", title: "Anfrage", desc: "Formular ausfüllen – optional mit Foto Ihrer Fläche." },
    { step: "02", title: "Besichtigung", desc: "Kurze kostenfreie Besichtigung oder Einschätzung per Foto." },
    { step: "03", title: "Angebot", desc: "Festpreis-Angebot, unverbindlich und transparent." },
    { step: "04", title: "Ausführung", desc: "Saubere Umsetzung zum vereinbarten Termin." },
];

export const TOWNS = [
    "Celle", "Hambühren", "Winsen (Aller)", "Wietze", "Eschede", "Lachendorf",
    "Bergen", "Unterlüß", "Nienhagen", "Wathlingen", "Faßberg", "Flotwedel",
];

export const SERVICE_OPTIONS = [
    "Heckenschnitt",
    "Pflasterreinigung",
    "Rasenpflege & Rasenreparatur",
    "Laubentfernung",
    "Sonstiges / Kombipaket",
];
